import type { ApolloError } from "@apollo/client";
import DailyEventsCalendar from "components/investorrelations/DailyEventsCalendar";
import parseDateYmd from "lib/utils/parseDateYmd";
import React from "react";
import { FormattedMessage } from "react-intl";
import type { IAgendaQuery } from "lib/queries/__generated__/AgendaQuery.generated";
import { EventsCalendarFilterRange } from "./enums";

interface EventsCalendarListProps {
  period: EventsCalendarFilterRange | null;
  searchQuery: string | null;
  loading: boolean;
  isLoadingMore: boolean;
  eventsCalendar?: IAgendaQuery;
  error?: ApolloError | undefined;
  loadMoreEvents: () => void;
  setCalendarInterval: (value: { startDate: Date; endDate: Date }) => void;
}

export default function EventsCalendarList({
  period,
  searchQuery,
  loading,
  eventsCalendar,
  isLoadingMore,
  error,
  loadMoreEvents,
  setCalendarInterval,
}: EventsCalendarListProps) {
  const isYearlyFilteringWithoutSearch = period === EventsCalendarFilterRange.InTheYear && !searchQuery;

  if (error) {
    return (
      <div className="rounded-md bg-red-50 p-4 font-aeonik font-normal tracking-wide dark:bg-red-900/30">
        <div className="flex">
          <div className="flex-1 md:flex md:justify-between">
            <p className="text-sm text-rose-700 dark:text-rose-200">
              <FormattedMessage
                defaultMessage="Não foi possível carregar os eventos. Por favor, tente novamente mais tarde."
                id="00HJni"
                description="Agenda"
              />
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (isYearlyFilteringWithoutSearch) {
    return (
      <div className="rounded-md bg-yellow-50 p-4 font-aeonik font-normal tracking-wide dark:bg-amber-900/30">
        <div className="flex">
          <div className="flex-1 md:flex md:justify-between">
            <p className="text-sm text-amber-700 dark:text-amber-200">
              <FormattedMessage
                defaultMessage={`A utilização do filtro "Todo Período" requer o uso da busca por ativo!`}
                id="Bijx5S"
                description="Agenda"
              />
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <DailyEventsCalendar
      events={eventsCalendar}
      isLoading={loading}
      isLoadingMore={isLoadingMore}
      onLoadMoreEvents={() => loadMoreEvents()}
      onGoToNextAgendaEvent={() => {
        if (eventsCalendar && eventsCalendar.agenda.nextUpcomingEventDateRange) {
          setCalendarInterval({
            startDate: parseDateYmd(eventsCalendar.agenda.nextUpcomingEventDateRange.filterByStartDate),
            endDate: parseDateYmd(eventsCalendar.agenda.nextUpcomingEventDateRange.filterByEndDate),
          });
        }
      }}
    />
  );
}
